import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { setConsoleAccessToken } from "@/lib/api";
import { appBasePath } from "@/lib/routes";

export default function ConsoleAccessEntry() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = searchParams.get("token")?.trim();
    if (!token) {
      setError("Missing access token. Open the store from the superadmin console.");
      return;
    }

    setConsoleAccessToken(token);
    const base = appBasePath();
    window.location.replace(base ? `${base}/` : "/");
  }, [searchParams]);

  if (error) {
    return (
      <div className="grid min-h-screen place-items-center bg-slate-950 px-4 text-center text-slate-200">
        <div className="max-w-md space-y-3">
          <h1 className="text-xl font-semibold text-white">Store access failed</h1>
          <p className="text-sm text-slate-400">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid min-h-screen place-items-center bg-brand-surface">
      <Loader2 className="h-8 w-8 animate-spin text-brand-primary" aria-hidden />
    </div>
  );
}

export function ConsoleAccessClosed() {
  return (
    <div className="grid min-h-screen place-items-center bg-slate-950 px-4 text-center text-slate-200">
      <div className="max-w-md space-y-3">
        <h1 className="text-xl font-semibold text-white">Support session ended</h1>
        <p className="text-sm text-slate-400">
          This superadmin store access tab has been closed. The store user&apos;s normal login was not affected.
        </p>
        <button
          type="button"
          className="rounded-lg bg-teal-500 px-4 py-2 text-sm font-medium text-slate-950"
          onClick={() => window.close()}
        >
          Close tab
        </button>
      </div>
    </div>
  );
}
